import { Link } from "react-router-dom"
import "./customerRow.css"

export function CustomerRow({ user }) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    const joinDateSplits = user.createdAt.split("-")

    const year = joinDateSplits[0]
    const month = months[parseInt(joinDateSplits[1]) - 1]
    const day = joinDateSplits[2].slice(0, 2)

    return (
        <table className="user-table">
            <tbody>
                <tr className="mt-3">
                    <td>
                        <div className="d-flex align-items-center ps-3 gap-3">
                            <div className="d-flex align-items-center admin-user-image rounded-circle">
                                <img
                                    src={user.profilePicture}
                                    width={40}
                                    height={40}
                                    className="rounded-circle border border-secondary"
                                    alt=""
                                />
                            </div>
                            <div className="admin-user-title">
                                {user.firstName + " " + (user.lastName ? user.lastName : "")}
                            </div>
                        </div>
                    </td>
                    <td className="">{user.email}</td>
                    <td>{user.phone}</td>
                    <td>{day + " " + month + " " + year}</td>
                    <td className="text-end px-3">
                        <Link
                            to={`/admin/customers/${user._id}`}
                            className="custom-btn primary text-center rounded-1 px-4 py-1">
                                View
                        </Link>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}